import React, { useState } from "react";
import { Column, Icon, Panel, Row } from "../../components";
import { PolicyDtoRead } from "../model/PolicyDtoRead";
import './CustomerPolicySummary.scss';
// import TextInputWithLabelFormGroup from "../../shared/components/input/TextInputWithLabelFormGroup";
import moment from "moment";
import { IconType } from "../../components/components/Icon/interfaces";
import { policyStatusMap } from "../../shared/util/constant";
import CustomerPolicyDetailView from "./customer-policy-detail-view/CustomerPolicyDetailView";
import { InfoDisplay } from "./InfoDisplay/InfoDisplay";
import { PolicySummaryHeader } from "./policy-summary-header/PolicySummaryHeader";
export interface ICustomerPolicySummary {
    policySummary: PolicyDtoRead,
    isEditPolicyActivated: boolean
};

const CustomerPolicySummary: React.FunctionComponent<ICustomerPolicySummary> = (props) => {
    const dateFormat = "MM/DD/YYYY"
    const policyTermValue = `${moment(props.policySummary.polEffDate).format(dateFormat)} - ${moment(props.policySummary.polExpDate).format(dateFormat)}`;

    //const websiteLauncherIcon = <Icon icon={'arrow-right' as IconType} className="icn-website-launcher" />;
    //const aplusRefLink = <a href={props.policySummary.policyAPlusUrl} target="_blank" >{props.policySummary.aPlusReferenceNumber} {props.policySummary.aPlusReferenceNumber ? websiteLauncherIcon : ''}</a>
    //const insuranceCompanyLink = <a href="#" >{props.policySummary.companyName} {props.policySummary.companyName ? websiteLauncherIcon : ''}</a>

    //const fullLg = 12;
    //const fullMd = 12;

    const [showReadDetails, setShowReadDetails] = useState(false);

    let policyBarStyle = {};
    if (props.policySummary.calculatedPolicyTermStatusId && policyStatusMap[props.policySummary.calculatedPolicyTermStatusId]) {
        policyBarStyle = policyStatusMap[props.policySummary.calculatedPolicyTermStatusId];
    }

    let isAddressHasValue = true;
    if (props.policySummary.address1 == '' && props.policySummary.address2 == '' && props.policySummary.city == ''
        && props.policySummary.state == '' && props.policySummary.zipCode == '') {
        isAddressHasValue = false;
    }
    let HideAddress = false;
    if (props.policySummary.address1 == null && props.policySummary.address2 == null && props.policySummary.city == null
        && props.policySummary.state == null && props.policySummary.zipCode == null) {
        HideAddress = true;
    }
    function getProductIcon(policyType: string): import("@fortawesome/fontawesome-svg-core").IconProp {
        switch (policyType) {
            case 'HO1':
            case 'HO2':
            case 'HO3':
            case 'Homeowners':
            case 'HO5':
            case 'HO7':
            case 'HO8':
            case 'HOA - Homeowners':
            case 'HOB - Homeowners':
            
            case 'HOC - Homeowners':
                return 'home';
            case 'HO6':
            case 'HOC - Condo':
                return 'building';
            case 'HO4':
            case 'HOC - Renters':
            case 'HOB - Renters':
                return 'key';
           case 'HOB - Condo':
                return 'building';
            case 'Mobile Home':
                return 'home';
            case 'Recreational Vehicles':
                return 'caravan';
            case 'Private Passenger Auto':
                return 'car';
            case 'LIFE':
                return 'heartbeat';
            case 'HEALTH':
                return 'medkit';
            case 'Earthquake':
                    return 'house-damage';
            case 'Boat':
                    return 'sailboat';
            case 'Inland Marine':
                    return 'briefcase';
            case 'Wind Policy':
                    return 'wind';
            case 'DP1':
            case 'DP3':
            case 'DP3 - Condo':
            case 'Dwelling Fire':
                    return 'fire';
            case 'Package':
            case 'Package (P)':
                    return 'boxes-packing';
            case 'Flood':
                    return 'water';
            case 'Excess Flood':
                    return 'water';
            case 'Specialty (P)':
                    return 'scale-balanced';
            case 'Umbrella (P)':
                    return 'umbrella';
            case 'Motorcycle':
                    return 'motorcycle';
            default:
                return 'question-circle';
        }
    }
    function handlePolicyClick(policyNumber: string): void {
       
        policyNumber = policyNumber?.replace(/[\s_-]/g, '');
       
        // You can add more logic here, such as navigating to a policy details page
        // For example, if using react-router:
        // history.push(`/policy-details/${policyNumber}`);
    }


    function handlePolicyAction(action: string): void {
        console.log(`Policy action selected: ${action}`);
        // Add more logic here if needed
    }

    return (
        <div className="panel-container">

            <Panel cardBodyClassName={'item-panel'}>
                <div className="container-summary-main">
                    {/* <div className="svg-wrapper">
                        <div className="background-lob-icon">
                            <FontAwesomeIcon
                                icon={getProductIcon(props.policySummary.lobCode)}
                            />
                        </div>
                    </div> */}
                    <div className="fixed-width" style={policyBarStyle}></div>
                    <div className="fill-width p-4">
                        <Row>
                            <Column lg={12}>
                                <div className="d-flex justify-content-start gap-3">
                                    <InfoDisplay
                                        caption="Policy Number"
                                        value={props.policySummary.policyNumber?.replace(/ /g, '')}
                                        icon={getProductIcon(props.policySummary.policyType)}
                                        onClick={() => handlePolicyClick(props.policySummary.policyNumber?.replace(/ /g, '') ?? '')}
                                        copyable bordered />
                                    <PolicySummaryHeader
                                        termValue={policyTermValue}
                                        polTermStatus={props.policySummary.polTermStatus}
                                        calCulatedpolTermStatus={props.policySummary.calculatedPolTermStatus}
                                        policyType={props.policySummary.policyType}
                                        policyStatusMap={policyStatusMap}
                                        onActionSelect={(action) => handlePolicyAction(action)}
                                      //  disabledActions={['cancellation', 'renew']}
                                        fullTermPremium={props.policySummary.fullTermPremium}
                                        isEditPolicyActivated={props.isEditPolicyActivated}
                                        policySummary={props.policySummary}
                                    />
                                </div>
                            </Column>
                        </Row>
                        <Row className="mt-4">
                            <Column md={12}>
                                <div className="d-flex align-items-start gap-5">
                                    {!HideAddress && (
                                    <InfoDisplay
                                        caption="Property Address"
                                        value={[
                                            props.policySummary.address1 + '\n',
                                            props.policySummary.address2 ? props.policySummary.address2 + '\n' : '',
                                            `${props.policySummary.city} ${isAddressHasValue ? ',' : ''} ${props.policySummary.state} ${props.policySummary.zipCode}`
                                        ].filter(Boolean).join('')}
                                        // icon="location-dot"
                                        copyable multiline
                                        showCopyButton={isAddressHasValue}
                                    />
                                    )}

                                    <InfoDisplay
                                        caption="Insurance Company"
                                        value={props.policySummary.companyName || 'N/A'}
                                        //onClick={() => window.open(props.policySummary.companyId, '_blank')}
                                        isExternal
                                    />

                                    <InfoDisplay
                                        caption="A+ Reference"
                                        value={props.policySummary.aPlusReferenceNumber || 'N/A'}
                                        // onClick={() => window.open(props.policySummary.policyAPlusUrl, '_blank')}
                                        onClick={e => {
                                            e.preventDefault();
                                            window.open(props.policySummary.policyAPlusUrl, '_blank');
                                        }}
                                        isExternal
                                    />

                                    <InfoDisplay
                                        caption="Source"
                                        value={props.policySummary.source || 'N/A'}
                                    />
                                </div>
                            </Column>
                        </Row>
                        
                            
                            <Row>
                                <Column lg={12}>
                                    <div className="icon-container">
                                    {
                                        !props.isEditPolicyActivated &&
                                        <button
                                            className="btn btn-sm btn-outline-primary d-flex align-items-center gap-1 rounded-pill px-3"
                                            onClick={() => setShowReadDetails(!showReadDetails)}
                                        >
                                            <Icon icon={showReadDetails ? 'caret-down' : 'caret-right'} />
                                            {showReadDetails ? 'Collapse' : 'Expand'}
                                        </button>
                                    }
                                    </div>
                                </Column>
                            </Row>
                        
                        <Row>
                            <Column lg={12}>
                                <div>
                                    {
                                    showReadDetails && <br></br> &&
                                     <CustomerPolicyDetailView 
                                     policySummary={props.policySummary}
                                     />
                                     }
                                </div>
                            </Column>
                        </Row>

                    </div>
                </div>
            </Panel>
        </div>
    );
}

export default CustomerPolicySummary;